export const AUTH_CONFIG = {
	domain: process.env.REACT_APP_AUTH0_DOMAIN || 'auth.reecall.co',
	clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
	container: 'auth0-login-container'
};
